<template>
  <section
    class="xb-section-container xb-cards"
    v-if="
      showDPBannerFlag ||
        notificationData.renewal.show ||
        (notificationData.preApplication.show && profileType === 2) ||
        notificationData.assessmentQualification.show ||
        (notificationData.resExamRegistration.show && profileType === 2)
    "
  >
    <xb-card
      v-if="
        (profileType === 2 && notificationData.renewal.show) ||
          (profileType === 1 &&
            !isEAAlreadyRenewed &&
            notificationData.renewal.show)
      "
      :title="notificationData.renewal.title"
      :renewalDeadline="notificationData.renewal.renewalDeadline"
      imgPath="/aceas/assets/common/vendor/xbase/img/icon/form-pin.png"
      :content="notificationData.renewal.content"
      :isRenewButtonDisabled="!isEligibleToRenew"
      :isNonRenewButtonDisabled="!isEligibleToNonRenew"
      :renewBtnTooltipText="
        !hasActiveFlag ? '' : 'You have initiated this application'
      "
      :dontWishToRenewBtnTooltipText="
        !hasNonRenewActiveFlag ? '' : 'You have initiated this application'
      "
      @renew="renew"
      @doNotRenew="doNotWishToRenew"
    />

    <xb-card
      v-if="showDPBannerFlag"
      :title="notificationData.dpRenewal.title"
      :renewalDeadline="notificationData.dpRenewal.renewalDeadline"
      imgPath="/aceas/assets/common/vendor/xbase/img/icon/form-pin.png"
      :content="notificationData.dpRenewal.content"
      :isRenewButtonDisabled="!isCanSubmitRenewalDp"
      @renew="renewDP"
    />

    <xb-card
      v-if="notificationData.preApplication.show && profileType === 2"
      :title="notificationData.preApplication.title"
      imgPath="/aceas/assets/common/vendor/xbase/img/icon/pre-application.png"
      :content="notificationData.preApplication.content"
    >
      <template v-slot:buttons>
        <button
          class="button xb-button is-secondary"
          @click="applyPreApplication"
        >
          Apply
        </button>
      </template>
    </xb-card>

    <xb-card
      v-if="notificationData.assessmentQualification.show"
      :title="notificationData.assessmentQualification.title"
      imgPath="/aceas/assets/common/vendor/xbase/img/icon/assessment-qualification.png"
      :content="notificationData.assessmentQualification.content"
    >
      <template v-slot:buttons>
        <button class="button xb-button is-secondary" @click="applyAQ">
          Apply
        </button>
      </template>
    </xb-card>

    <xb-card
      :title="notificationData.resExamRegistration.title"
      imgPath="/aceas/assets/common/vendor/xbase/img/icon/form-clip.png"
      :content="notificationData.resExamRegistration.content"
      v-if="
        notificationData.resExamRegistration.show &&
          profileType === 2 &&
          $store.state.config.configurationData.environment !== 'prd'
      "
    >
      <template v-slot:buttons>
        <button
          class="button xb-button is-secondary"
          @click="applyResExamRegistration"
        >
          Apply
        </button>
      </template>
    </xb-card>
  </section>
</template>

<script>
const mapState = window.Vuex.mapState;

import baseService from "./../../../services/index";

/**
 * DOCUMENTATION: READ ME FIRST
 * - RES
 *   -- Renewal Period box : will be shown when entering renewal period (THIS ONE NOT IMPLEMENTED YET ON BE)
 *      -- API : APP MGMT RENEWAL
 *      -- Show condition : date returned from renewal is true
 *      -- Who can see this : EA and RES
 *   -- RES Exam Registration : will be shown when have not taken any exam
 *      -- API : EXAM MGMT
 *      -- Show condition : hasTakenExam response value is false
 *      -- Who can see this : RES
 *   -- Pre-Application : will be shown when MOP is recommended to do pre-app
 *      -- API : PROFILE MGMT
 *      -- Show condition :
 *            -- Convicted court answered Yes (DONE ON PROFILE MANAGEMENT)
 *            -- Fit and proper criteria answered No (DONE ON PROFILE MANAGEMENT)
 *            -- Has a valid Assessment of Qualification (AQ) or does not require AQ (THIS ONE NOT IMPLEMENTED YET ON BE)
 *      -- Who can see this : RES
 */
export default {
  name: "SpecialNotifBoxes",
  props: {
    showRenewalBannerFlag: {
      type: Object,
      required: true
    },
    isEnteringRenewalPeriod: {
      type: Object,
      required: true
    },
    additionalProfileInfo: {
      type: Object,
      required: true
    },
    isEligibleToRenew: {
      type: Boolean,
      required: false
    },
    isEligibleToNonRenew: {
      type: Boolean,
      required: false
    },
    isCanSubmitRenewalDp: {
      type: Boolean,
      required: false
    },
    showDPBannerFlag: {
      type: Boolean,
      required: false
    },
    hasActiveFlag: {
      type: Boolean,
      required: false
    },
    hasNonRenewActiveFlag: {
      type: Boolean,
      required: false
    },
    isRESAlreadyRenewed: {
      type: Boolean,
      required: false
    },
    isEAAlreadyRenewed: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      hasTakenExam: true,
      hasPreAppApplication: false,
      isRecommendedToTakePreApplication: false,
      renewalRedirectionDelay: 3000,
      renewalContentAdditionalWording:
        "<br/><br/>Please note that KEOs <b>do not need to submit a separate RES registration renewal application</b>, as this will be submitted automatically when the EA licence renewal application is submitted.",
      notificationData: {
        renewal: {
          content:
            "<b>Sorry! You are <font class='has-text-danger'>not eligible</font> to renew your salesperson registration .</b><br/> If you wish to apply to renew, please fulfill our CPD and CPF requirements. If you do not wish to renew, you do not have to fulfill the requirements.",
          title: ``,
          renewalDeadline: "31 Oct 2021",
          show: false
        },
        dpRenewal: {
          content:
            'You are a <u>Director/Partner of an Estate Agent (EA)</u>. Please proceed to submit your Director/Partner renewal application to the EA so that it may renew its EA Licence and your director/partner role in the EA.<br/><br/>Note:<br/>If you have director/partner role in multiple EAs, you will only need to submit a single Director/Partner renewal application.<br/><br/>For practising director/partner, who is a real estate salesperson (RES) with the EA, you will need to fulfil both the Continuing Professional Development (CPD) requirements and Central Provident Fund (CPF) MediSave contribution in the "Overview".<br/><br/>For non-practising director/partner, who is not a RES with the EA, you will not need to fulfil the CPD requirements and CPF MediSave contribution.<br/><br/>Please ensure that your details in the profile are updated first so that the correct information can be pre-populated when initiating your Director/Partner renewal application.',
          title: ``,
          renewalDeadline: "31 Oct 2021",
          show: false
        },
        resExamRegistration: {
          title: "RES Exam Registration",
          content: `To register as a salesperson, you must pass the RES exam.<br/>Apply for RES exam today.`,
          show: false
        },
        preApplication: {
          title: "Pre-Application",
          content: `If you are unsure if you fulfill CEA's fit and proper criteria for registering as a salesperson, you can consider submitting a pre-application assessment
        <br/>This assessment allows CEA to review if you fulfill the relevant criteria.
        `,
          show: false
        },
        assessmentQualification: {
          title: "Assessment of Qualification",
          content: `If you are unsure if you fulfill CEA's education criterion for registering as a salesperson, you can consider submitting an Assessment of Qualification.
          <br/>This assessment allows CEA to review if you fulfill the relevant criteria.
          `,
          show: false
        }
      }
    };
  },
  computed: {
    ...mapState({
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken,
      sgID: state => state.header.userProfile.sgID,
      profileType: state => state.header.userProfile.profileType //1 for EA, 2 for RES
    }),
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    },
    currentYear() {
      return new Date().getFullYear();
    },
    notAllowedRolesIdentified() {
      const notAllowedRoles = ["director", "partner"];
      let notAllowedRolesIdentified = false;
      notAllowedRoles.forEach(role => {
        if (this.$store.state.header.userProfile.roles.includes(role))
          notAllowedRolesIdentified = true;
      });
      return notAllowedRolesIdentified;
    }
  },
  watch: {
    showRenewalBannerFlag: {
      immediate: true,
      deep: true,
      handler(val) {
        this.notificationData.renewal.show = val;
      }
    },
    isEnteringRenewalPeriod: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.profileType === 1) {
          this.notificationData.renewal.show = val.status;
        }
        this.notificationData.renewal.renewalDeadline =
          val.deadlineDate || null;
        this.notificationData.dpRenewal.renewalDeadline =
          val.deadlineDate || null;
      }
    },
    hasTakenExam: {
      immediate: true,
      handler(val) {
        if (val) {
          this.notificationData.resExamRegistration.show = false;
        } else {
          this.notificationData.resExamRegistration.show = true;
        }
      }
    },
    isRecommendedToTakePreApplication: {
      immediate: true,
      handler(val) {
        if (val) {
          this.notificationData.preApplication.show = true;
        } else {
          this.notificationData.preApplication.show = false;
        }
      }
    },
    isEligibleToRenew: {
      immediate: true,
      handler(val) {
        if (this.profileType === 1) {
          const notEligibleText =
            "Sorry! You are <b>not eligible</b> to renew your EA licence.<br/><br/> If you wish to apply to renew, please ensure that your KEO fulfills our CPD and CPF requirements. If you do not wish to renew, you do not have to fulfill the requirements.";
          const eligibleText =
            "You are <b>eligible to renew</b> your Estate Agent Licence.<br/><br/> Please ensure that the details of both your Estate Agent and your Key Executive Officer are updated first in their respective profile module so that the correct information can be pre-populated when initiating your Estate Agent Licence renewal application.";
          this.$set(
            this.notificationData.renewal,
            "content",
            (!val ? notEligibleText : eligibleText) +
              this.renewalContentAdditionalWording
          );
        } else {
          const notEligibleText =
            "Sorry! You are <b>not eligible</b> to renew your salesperson registration.<br/><br/> If you wish to apply to renew, please fulfill our CPD and CPF requirements. If you do not wish to renew, you do not have to fulfill the requirements.";
          const eligibleText =
            "You are <b>eligible to renew</b> your Salesperson Registration with <u>the Estate Agent that you are currently registered with</u>.<br/><br/> Please ensure that your details in the profile are updated first so that the correct information can be pre-populated when initiating your Salesperson renewal application.";
          this.$set(
            this.notificationData.renewal,
            "content",
            (!val ? notEligibleText : eligibleText) +
              this.renewalContentAdditionalWording
          );

          // this.notificationData.renewal.content = !val
          //   ? notEligibleText
          //   : eligibleText;
        }
      }
    },
    hasActiveFlag: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.profileType === 1) {
            const eligibleText =
              "You are <b>eligible to renew</b> your Estate Agent Licence.<br/><br/> Please ensure that the details of both your Estate Agent and your Key Executive Officer are updated first in their respective profile module so that the correct information can be pre-populated when initiating your Estate Agent Licence renewal application." +
              this.renewalContentAdditionalWording;
            this.$set(this.notificationData.renewal, "content", eligibleText);
          } else {
            const eligibleText =
              "You are <b>eligible to renew</b> your Salesperson Registration with <u>the Estate Agent that you are currently registered with</u>.<br/><br/> Please ensure that your details in the profile are updated first so that the correct information can be pre-populated when initiating your Salesperson renewal application." +
              this.renewalContentAdditionalWording;
            this.$set(this.notificationData.renewal, "content", eligibleText);
          }
        }
      }
    }
  },
  mounted() {
    if (this.profileType === 1) {
      // this.notificationData.renewal.content =
      //   "<b>Sorry! You are <font class='has-text-danger'>not eligible</font> to renew your EA licence.</b><br/> If you wish to apply to renew, please ensure that your KEO fulfills our CPD and CPF. If you do not wish to renew, you do not have to fulfill the requirements.";
      this.notificationData.renewal.title = `EA Licence Renewal ${this.currentYear}`;
    } else {
      this.notificationData.renewal.title = `Salesperson Registration Renewal ${this.currentYear}`;
    }
    this.notificationData.dpRenewal.title = `Director/Partner Renewal ${this.currentYear}`;

    if (this.profileType === 2) {
      this.getExamStatus();
      this.$nextTick(() => {
        this.calculatePreApplicationCondition();
      });
    }
  },
  methods: {
    applyAQ() {
      window.location.href =
        "/aceas/qualification-management/assessment-of-qualification/intro";
    },
    applyPreApplication() {
      window.location.href = "/aceas/pre-application/intro";
    },
    applyResExamRegistration() {
      if (this.profileType == 1) {
        window.location.href = "/aceas/REA-exam-management/application/intro";
      } else {
        window.location.href = "/aceas/RES-exam-management/application/intro";
      }
    },
    renew() {
      this.$emit("triggerLoading", true);

      if (this.profileType === 2) {
        const endpoint = this.apiConfig.common_module.appManagement
          .getRenewalInitiationEndpoint;

        baseService(
          endpoint,
          { sgId: this.sgID },
          this.renewalSuccess,
          this.handleRenewalOrNonRenewalFailed,
          this.headerOptions
        );
      } else {
        const endpoint = this.apiConfig.common_module.appManagement
          .getEARenewalInitiationEndpoint;

        baseService(
          endpoint,
          {},
          this.renewalSuccess,
          this.handleRenewalOrNonRenewalFailed,
          this.headerOptions
        );
      }
    },
    renewalSuccess(res) {
      if (this.profileType === 2) {
        const data = res.data.data;
        const applicationId = data.applicationId ? data.applicationId : data;

        setTimeout(() => {
          this.$emit("triggerLoading", false);
          window.location.href = `/aceas/RES-Management/renewal/${applicationId}/intro`;
        }, this.renewalRedirectionDelay);

        // this.$router.push({ path: "/RES-Management/renewal" });
      } else {
        this.$emit("triggerLoading", false);
        const data = res.data.data;
        const referenceNo = data;
        window.location.href = `/aceas/EA-Management/EA-licence-renewal/${referenceNo}/intro`;

        // setTimeout(() => {
        //   this.$emit("triggerLoading", false);
        //   this.$buefy.snackbar.open({
        //     message:
        //       "Your Application is being initiated. The System will send invitation emails for your Directors/Partners to submit Renewal Application Form.",
        //     type: "is-success",
        //     position: "is-top",
        //     actionText: "✖"
        //   });
        //   this.$router.push({ path: "/EA-Management/EA-licence-renewal" });
        // }, this.renewalRedirectionDelay);
      }
    },
    renewDP() {
      window.location.href = `/aceas/EA-Management/director-partner-renewal/intro`;
    },
    formatDate(date) {
      if (!date) return "";
      return this.$_globalMixin_displaySGT(new Date(date), "d MMM yyyy");
    },
    doNotWishToRenew() {
      const renewalDeadline = this.$store.state.header.userProfile
        .additionalProfileInfo.validityDateEnd;
      this.$buefy.dialog.confirm({
        message:
          this.profileType === 2
            ? `Are you sure you do not want to renew? Your RES Registration will expire on ${this.formatDate(
                renewalDeadline
              )}`
            : `Are you sure you do not want to renew? Your EA licence will expire on ${this.formatDate(
                renewalDeadline
              )}`,
        onConfirm: async () => {
          this.$emit("triggerLoading", true);
          if (this.profileType === 2) {
            const endpoint = this.apiConfig.common_module.appManagement
              .getNonRenewalInitiationEndpoint;

            baseService(
              endpoint,
              { sgId: this.sgID },
              this.nonRenewalSuccess,
              this.handleRenewalOrNonRenewalFailed,
              this.headerOptions
            );
          } else {
            window.location.href = `/aceas/EA-Management/EA-licence-non-renewal/intro`;
          }
        },
        cancelText: "Cancel",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true
      });
    },
    nonRenewalSuccess(res) {
      this.$emit("triggerLoading", false);
      if (this.profileType === 2) {
        const data = res.data.data;
        const applicationId = data.applicationId;
        window.location.href = `/aceas/RES-Management/non-renewal/${applicationId}/intro`;
      }
    },
    handleRenewalOrNonRenewalFailed(error) {
      this.$emit("triggerLoading", false);
      const message =
        error.response.data &&
        error.response.data.data &&
        error.response.data.data.message
          ? typeof error.response.data.data.message === "string"
            ? error.response.data.data.message
            : error.response.data.data.message[0]
          : error.response.message || error.message;
      this.$buefy.dialog.alert({
        message: `<h2 class='is-danger'>Error</h2> ${message}`,
        type: "is-danger",
        hasIcon: true,
        icon: "times",
        iconPack: "fa"
      });
    },
    /**
     * Function to get exam status
     * to decide whether exam registration box shown or not
     */
    getExamStatus() {
      const endpoint = this.apiConfig.common_module.examManagement
        .getHasExamStatus;

      baseService(
        endpoint,
        {},
        this.handleGetExamStatusSuccess,
        this.handleFailed,
        this.headerOptions
      );
    },
    handleGetExamStatusSuccess(response) {
      this.hasTakenExam = response.data.data.hasTakenExam;
    },
    handleFailed(e) {
      return e;
    },
    /**
     * Function to calculate pre-app condition
     * to decide whether pre-app box shown or not
     */
    calculatePreApplicationCondition() {
      const endpoint = this.apiConfig.common_module.qualificationManagement
        .getHasAQStatusEndpoint;
      let payload =
        this.profileType === 2 ? { nric: this.sgID } : { uen: this.sgID }; // change this to this.sgID later

      payload = { ...payload, status: "Approved" };
      baseService(
        endpoint,
        payload,
        this.parseDeclarationInfo,
        this.handleFailed,
        this.headerOptions
      );
    },
    async getPreAppApplications() {
      const endpoint = this.apiConfig.common_module.appManagement
        .getPreAppActiveApplications;

      await baseService(
        endpoint,
        {},
        this.setHasPreAppApplication,
        this.handleFailed,
        this.headerOptions,
        "get"
      );
    },
    setHasPreAppApplication(response) {
      this.hasPreAppApplication = response.data.data > 0 ? true : false;
    },
    async parseDeclarationInfo(qualificationResponse) {
      const _this = this;
      const hasValidAQ = qualificationResponse.data.data.length > 0;

      const {
        have4passFlag,
        gceLevelFlag
      } = this.additionalProfileInfo.profileDetailDto.educationInfoJson;

      const isNeedAQDataToCalculatePreAppCondition =
        !hasValidAQ && !have4passFlag && !gceLevelFlag;

      if (isNeedAQDataToCalculatePreAppCondition) {
        this.$set(this.notificationData.assessmentQualification, "show", true);
      }

      const declarationInfo = this.additionalProfileInfo.profileDetailDto
        .declarationJson;

      const isConvictedCourt = declarationInfo.declarations.convictedCourt;

      const isFitAndProperQuestion =
        declarationInfo.declarations.fitProperCriteria;

      // check if user eligible to access /pre-app
      if (
        _this.$can("READ", "/app/pre-app") &&
        isConvictedCourt &&
        !isFitAndProperQuestion &&
        (hasValidAQ || !isNeedAQDataToCalculatePreAppCondition)
      ) {
        await this.getPreAppApplications();

        if (!this.hasPreAppApplication) {
          this.isRecommendedToTakePreApplication = true;
        }
      }
    }
  }
};
</script>

<style></style>
